<div class="confirm-popup text-center">
    <h2 class="form-modal__title modal-title app-c-heading--h3">{{title}}</h2>
    <div class="modal-message-container">
        <div class="form-modal__body">
            <div [innerHtml]="message"></div>
            <p *ngIf="helpLine">{{helpLine}}</p>
        </div>
    </div>
    <div class="footer">
        <button
            (click)="dialogRef.close()"
            class="app-c-btn app-c-btn--secondary app-c-btn--curve">
            {{cancelTxt ? cancelTxt : 'setting.no' | translate}}
        </button>
        <button
            (click)="dialogRef.close(true)"
            class="app-c-btn app-c-btn--primary app-c-btn--curve primary-button"
            translate>
            {{okTxt ? okTxt : 'setting.yes' | translate}}
        </button>
    </div>
</div>
